/* global document window */

/**
 * @summary Send HTTP request. Can be used to reload page,
 * load controller instance variables and perform render
 * Example: add field to account from country crops map
 * Reason: ordinary ajax call can't provide it because of
 * data size restriction
 * @param {*} settings
 * @property {string} action - form action url
 * @property {string} method - HTTP request method
 * @property {boolean} sendInNewWindow - form target attribute
 * @property {object} params - object of form data
 */
export default function sendRequestAsForm({
  action, method, sendInNewWindow, params = {},
}) {
  const form = document.createElement('form');
  const body = document.getElementsByTagName('body')[0];
  const csrf = document.getElementsByName('csrf-token')[0];

  form.setAttribute('action', action);
  form.setAttribute('method', method);

  if (sendInNewWindow) {
    form.setAttribute('target', 'NewWindow');
  }

  if (csrf) {
    // eslint-disable-next-line no-param-reassign
    params.authenticity_token = csrf.getAttribute('content');
  }

  Object
    .entries(params)
    .forEach(([name, value]) => {
      const input = document.createElement('input');

      input.setAttribute('type', 'hidden');
      input.setAttribute('name', name);
      input.setAttribute('value', value);

      form.append(input);
    });

  body.append(form);

  if (sendInNewWindow) {
    window.open('', 'NewWindow');
  }

  form.submit();

  if (sendInNewWindow) {
    form.parentNode.removeChild(form);
  }
}
